import { maLookback } from './ma'

/**
 * Lookback helpers that metas import EAGERLY (every meta is in the main bundle via
 * import.meta.glob). They live here, away from the calc code, so a meta never drags
 * a maths module into the eager bundle — only ma.ts' tiny maLookback comes along.
 */

/** TA_PLUS_DM_Lookback / TA_MINUS_DM_Lookback. */
export const dmLookback = (n: number): number => (n > 1 ? n - 1 : 1)

/** Keltner: MA(close) ± k·ATR — defined once both are. */
export const keltnerLookback = (n: number, matype: number, atrperiod: number): number => Math.max(maLookback(n, matype), atrperiod)

/** Accelerator Oscillator: AO (max(fast, slow) − 1) then its signal SMA. */
export const acLookback = (fast: number, slow: number, signal: number): number => Math.max(fast, slow) - 1 + (signal - 1)

/** Coppock: WMA(n) over ROC(t1) + ROC(t2). */
export const coppockLookback = (n: number, t1: number, t2: number): number => Math.max(t1, t2) + n - 1
